import axiosInstance from "./axiosInstance";

export const obtenerPrecioAmenidades = async (signal) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerPrecioAmenidades`,
    { withCredentials: true, signal }
  );
};
